import { render, staticRenderFns } from "./offerTeaser.vue?vue&type=template&id=26ae7f2e&"
import script from "./offerTeaser.vue?vue&type=script&lang=js&"
export * from "./offerTeaser.vue?vue&type=script&lang=js&"
import style0 from "./offerTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ae7f2e')) {
      api.createRecord('26ae7f2e', component.options)
    } else {
      api.reload('26ae7f2e', component.options)
    }
    module.hot.accept("./offerTeaser.vue?vue&type=template&id=26ae7f2e&", function () {
      api.rerender('26ae7f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/offerTeaser/offerTeaser.vue"
export default component.exports